import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface getMessagesParameter extends ApiParameter {
    Id: string;
    size: number;
    type: string;
}

export interface MessageCollectionModel {
    uri: string;
    id: string;
    body: string;
    subject: string;
    dateToDisplay: string;
    isRead: boolean;
    displayName: string;
    properties: Properties;
}

export interface Properties {}

const url = "/api/v2/messages";

export const getCustomMessages = async (parameter: getMessagesParameter) => {
    const response = await get<MessageCollectionModel[]>(`${url}?date=${new Date().toISOString()}`, parameter);
    return response;
};
